module.exports = function() {

  var initials = function(name) {
    if (typeof name === 'string') {
      name = name.trim().split(/[ -]/);
      return initial(name.shift()) + initial(name.pop());
    }
  };

  var initial = function(name) {
    return (name || '').charAt(0).toUpperCase();
  };

  return {
    template: require('html/templates/initials'),
    restrict: 'E',
    replace: true,
    scope: { name: '@' },
    link: function(scope) {
      scope.initials = initials;
    }
  };

};



/*****************
 ** WEBPACK FOOTER
 ** ./src/js/directives/initials.js
 ** module id = 144
 ** module chunks = 1
 **/